









































































































































































import { UserServiceProxy } from '@/service-proxies/app-v2/user.service-proxies'
import { MasterlinkRoleServiceProxy, RoleVO } from '@/service-proxies/app-v2/system.service-proxies'
import Vue from 'vue'
import moment from 'moment'
import dayjs from 'dayjs'
import { getUserInfo } from '@/utils/auth'
const masterlinkroleservice = new MasterlinkRoleServiceProxy()
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 }
}
const UserService = new UserServiceProxy()
export default Vue.extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({})
    },
    treeData: {
      type: Array,
      default: () => ({})
    },
    organizeData: {
      type: Array,
      default: () => []
    },
    positionData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formItemLayout,
      form: this.$form.createForm(this),
      rolesList: [],
      value: undefined,
      deptIds: []
    }
  },
  watch: {
    'item.id': {
      handler() {
        this.form.resetFields()
        masterlinkroleservice.getRoles(undefined, undefined).then((res: any) => {
          if (res.data) {
            this.rolesList = res.data.roleVOList
          }
        })
        this.reloadDeptIds(this.treeData)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    moment,
    onClose() {
      this.form.resetFields()
      this.$emit('close', false)
    },
    reloadDeptIds(value) {
      this.deptIds = []
      value.forEach((element) => {
        this.recheckData(element)
      })
    },
    recheckData(data) {
      const ids = this.item.deptId.split(',')
      const value = {
        label: data.title,
        value: data.key
      }
      if (data.children && data.children.length > 0) {
        data.children.forEach((element) => {
          return this.recheckData(element)
        })
      }
      if (ids.includes(value.value)) {
        this.deptIds.push(value)
      }
    },
    save() {
      this.form.validateFields((err: any, values: any) => {
        if (!err) {
          if (values.birthday) {
            values.birthday = dayjs(Number(values.birthday)).format('YYYY-MM-DD HH:mm:ss')
          }
          const user = getUserInfo()
          values.tenantId = user.tenant_id
          values.id = this.item.id
          values.organizationId = values.organizationId ? values.organizationId.join(',') : ''
          values.postId = values.postId ? values.postId.join(',') : ''
          values.roleId = this.recheck(values.roleId)
          values.deptId = values.deptId ? values.deptId.join(',') : ''
          UserService.update(values).then((res) => {
            this.$message.success(this.$t('page_user_management_modified_success'))
            this.form.resetFields()
            this.$emit('close', true)
          })
        }
      })
    },
    recheck(values: any) {
      const roleIds: string[] = []
      this.rolesList.forEach((res: RoleVO) => {
        if (values.indexOf(res.roleName) !== -1) {
          roleIds.push(res.id)
        }
      })
      return roleIds.join(',')
    }
  }
})
